import styled from 'styled-components';
import { device } from '@jjj/components';

export const NoTalentFoundWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const Title = styled('div')`
  @media ${device.tablet} {
    padding: 0 90px;
  }
`;

export const TableWrapper = styled.div`
  margin-top: 35px;
  margin-bottom: 25px;

  .table-search-input {
    width: 100%;

    .input-search {
      width: 100% !important;
    }
  }

  .ant-table-wrapper,
  .table-search-input {
    @media ${device.tablet} {
      padding: 0 90px;
    }
  }
`;
